/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_License_Bullet_TestsInputs */

const en_marketing_license_bullet_tests = /** @type {(inputs: Marketing_License_Bullet_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The docs site, tests, and CI pipeline`)
};

const es_marketing_license_bullet_tests = /** @type {(inputs: Marketing_License_Bullet_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El sitio de documentación, las pruebas y el pipeline de CI`)
};

const fr_marketing_license_bullet_tests = /** @type {(inputs: Marketing_License_Bullet_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le site de documentation, les tests et le pipeline CI`)
};

/**
* | output |
* | --- |
* | "The docs site, tests, and CI pipeline" |
*
* @param {Marketing_License_Bullet_TestsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_license_bullet_tests = /** @type {((inputs?: Marketing_License_Bullet_TestsInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_License_Bullet_TestsInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_license_bullet_tests(inputs)
	if (locale === "es") return es_marketing_license_bullet_tests(inputs)
	return fr_marketing_license_bullet_tests(inputs)
});